// @flow

import React from 'react';
import PropTypes from 'prop-types';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import {makeStyles} from '@material-ui/styles';
import {Grid, Typography} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';

//$FlowFixMe
import dayJsUtils from '@date-io/dayjs';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import CustomDatePicker from '../../../marketing/coupons/components/CustomDatePicker/CustomDatePicker';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {useState} from 'react';

type Props = {
  open: boolean,
  setOpen: (v: boolean) => void,
  setDateConfig: (date: any) => void,
  setPeriodValue: (date: any) => void,
};

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 320,
  },
  title: {
    color: colors.grey900,
    fontWeight: 600,
    fontSize: 18,
    textAlign: 'center',
  },
  content: {
    margin: theme.spacing(2, 0),
  },
  btnApply: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  btn: {
    width: '10rem',
    maxWidth: '90%',
  },
}));
export default function CustomDateModal(props: Props) {
  const {open, setOpen, setDateConfig, setPeriodValue} = props;
  const classes = useStyles();

  const [initDate, setInitDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [availableEnd, setAvailableEnd] = useState(false);

  const handleChangeDate = (date?: Date, type: string) => {
    if (date) {
      if (type === 'start') {
        setAvailableEnd(false);
        setInitDate(date);
        setAvailableEnd(true);
      } else {
        setEndDate(date);
      }
    }
  };

  const onConfirm = () => {
    if (initDate && endDate) {
      setDateConfig({
        init_date: new Date(initDate),
        end_date: new Date(endDate),
      });
      setPeriodValue('custom');
      setOpen(false);
    }
  };

  return (
    <CustomModal open={open} handleCloseModal={() => setOpen(false)}>
      <div className={classes.root}>
        <Typography className={classes.title}>
          Escoge el rango de fecha
        </Typography>

        <MuiPickersUtilsProvider utils={dayJsUtils}>
          <div className={classes.content}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <CustomDatePicker
                  label="Desde"
                  handleChange={date => handleChangeDate(date, 'start')}
                  value={initDate}
                />
              </Grid>
              <Grid item xs={12}>
                <CustomDatePicker
                  disabled={!availableEnd}
                  label="Hasta"
                  handleChange={date => handleChangeDate(date, 'end')}
                  value={endDate}
                  minDate={initDate}
                  minDateMessage={
                    'La fecha debe ser posterior a la fecha de inicio'
                  }
                />
              </Grid>

              <Grid item xs={12}>
                <div className={classes.btnApply}>
                  <CustomButton
                    disabled={!availableEnd}
                    className={classes.btn}
                    variant="contained"
                    onClick={onConfirm}
                  >
                    Aplicar
                  </CustomButton>
                </div>
              </Grid>
            </Grid>
          </div>
        </MuiPickersUtilsProvider>
      </div>
    </CustomModal>
  );
}

CustomDateModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  setDateConfig: PropTypes.func.isRequired,
  setPeriodValue: PropTypes.func.isRequired,
};
